import { Injectable } from '@angular/core';

// A data view a page shows, with the page's current selections, read when Ask Zeus
// sends a question. The id is the contract with the Zeus data guide.
export interface PageSelectionsView {
  id: string;
  read: () => Record<string, unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class PageSelectionsService {
  private readonly views = new Map<object, PageSelectionsView>();

  public register(owner: object, view: PageSelectionsView): void {
    this.views.set(owner, view);
  }

  public unregister(owner: object): void {
    this.views.delete(owner);
  }

  // Components that share a view id (e.g. a page and its table) merge their selections.
  public snapshot(): { id: string; selections: Record<string, unknown> }[] {
    const merged = new Map<string, Record<string, unknown>>();
    for (const { id, read } of this.views.values()) {
      merged.set(id, { ...merged.get(id), ...read() });
    }
    return [...merged].map(([id, selections]) => ({ id, selections }));
  }
}
